
/**
 * 是否为新uc登录方案
 *
 * 在目前的私有化方案中, 有两种登录方案, irc 和 新uc(以下简称nuc), 各为不同的登录服务
 *
 * 目前的何肿EC使用irc登录方案, 辽肿使用nuc登录方案, 后续何肿EC和云端可能也会迁移至nuc的登录方式
 * 待所有接入方式全部迁移至nuc时, 可删除此变量及相应的判断
 */
const isNuc = ((window as { LOGIN_SCHEME?: string }).LOGIN_SCHEME || process.env.VUE_APP_LOGIN_SCHEME) === 'nuc';


export {
  isNuc,
};
